import { WarningBanner } from 'ui/banner';
import { Button } from 'ui/button';
import { BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button/constants';
import { Modal, ModalFooter, ModalHeader, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { StyledModalBody } from '../Styled';

type ModalContent = {
  header: string;
  bodyMsg: string;
  bodyWarning: string;
  buttonTextPublish: string;
  buttonTextSaveNew: string;
};

const modalContent: ModalContent = {
  header: 'Save snippet?',
  bodyMsg: `Don't want to update the campaigns and templates that use this snippet? Save as a new snippet instead.`,
  bodyWarning: `Changes will be applied everywhere this snippet is used.`,
  buttonTextPublish: 'Publish changes',
  buttonTextSaveNew: 'Save as new',
};

type Props = {
  closeModal: () => void;
  handleCopy: () => void;
  handlePublish: () => void;
};

export const SaveSnippetModal = ({ closeModal, handleCopy, handlePublish }: Props) => {
  return (
    <Modal
      data-test="snippet-save-modal"
      id="saveSnippetModal"
      isModalOpen={true}
      onClose={closeModal}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
    >
      <ModalHeader autoFocus={false}>{modalContent.header}</ModalHeader>

      <StyledModalBody>
        <WarningBanner Icon={false}>{modalContent.bodyWarning}</WarningBanner>
        {modalContent.bodyMsg}
      </StyledModalBody>

      <ModalFooter>
        <Button onClick={handleCopy} size={BUTTON_SIZES.LARGE} variant={BUTTON_VARIANTS.SECONDARY}>
          {modalContent.buttonTextSaveNew}
        </Button>
        <Button onClick={handlePublish} size={BUTTON_SIZES.LARGE} variant={BUTTON_VARIANTS.PRIMARY}>
          {modalContent.buttonTextPublish}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
